import type { BomSupply } from "../../api/manufacturing";

/** Any translate function: the hook's `t`, or a config page's plain one. */
type Translate = (key: string, fallback: string) => string;

/** How a parent order gets a component, in the plant's words. */
export function bomSupplyLabel(supply: BomSupply, t: Translate): string {
  switch (supply) {
    case "PHANTOM":
      return t("bom-supply.phantom", "Phantom: its materials, directly");
    case "FROM_STOCK":
      return t("bom-supply.from-stock", "From stock");
  }
}
